<script lang="ts">
    import PostHero from '$lib/components/PostHero.svelte';
    import type { ExhibitionQuery } from '$gen/graphql';
    import BigInseratGrid from '$lib/ads/BigInseratGrid.svelte';
    import { ads } from '$lib/stores';
    import { shuffle } from 'lodash-es';
    import MorePosts from '$lib/components/MorePosts.svelte';
    import SeoMetaTagsExhibition from '$lib/components/SeoMetaTagsExhibition.svelte';
    import { isExhibition } from '$lib/api/kubaparis/fragments';
    import VideoEmbed from '$lib/components/VideoEmbed.svelte';
    import SingleImage from '$lib/components/blocks/SingleImage.svelte';
    import ImageWithCaption from './ImageWithCaption.svelte';

    export let query: ExhibitionQuery;
    let images = [];

    $: post = query && isExhibition(query.exhibition) ? query.exhibition : null;
    $: if (post) {
        images = [];
        post.images.rows.forEach((row) => {
            const img = row?.image[0]?.__typename === 'submissions_Asset' ? row.image[0] : null;
            if (img) {
                let formatClass;
                if(img.width > img.height) {
                    formatClass = 'landscape';
                } else {
                    formatClass = 'portrait';
                }
                images.push({
                    url: img.url || '',
                    description: row.caption || '',
                    width: img.width || 1920,
                    height: img.height || 1080,
                    srcset: img.srcset || '',
                    formatClass: formatClass,
                });
            }
        });
        images = images;
        console.log(images);
    }

    $: morePosts = query ? [].concat(query.morePosts, query.moreExhibitions) : [];
</script>

<SeoMetaTagsExhibition
    title={post?.exhibitionTitle}
    description={post?.subheadline}
    imageUrl={post?.seoImage[0]?.url}
/>

<PostHero
    title={post.exhibitionTitle}
    artists={post.artistsName}
    curator={post.curator}
    locationName={post.locationName}
    locationLink={post.linkToLocation}
    topColor={post?.topColor[0]?.__typename === 'colors_Category' ? post.topColor[0].color : null}
    bottomColor={post?.bottomColor[0]?.__typename === 'colors_Category'
        ? post.bottomColor[0].color
        : null}
    textAuthor={post.textAuthor}
    photographer={post.photographer}
/>

{#if images?.length > 0}
    {#each images.slice(0, 1) as img}
        <ImageWithCaption {img} />
    {/each}
{/if}

{#if post?.subheadline}
    <section class="px-0 text-2xl leading-6 lg:px-5">
        {post.subheadline}
    </section>
{/if}

{#if $ads.big.length > 0}
    <section class="hidden auto-rows-min grid-cols-1 gap-5 lg:grid lg:grid-cols-3">
        <BigInseratGrid ads={shuffle($ads.big).slice(0, 3)} />
    </section>
{/if}
{#if post.linkToVideo}
    <VideoEmbed url={post.linkToVideo} />
{/if}

{#if images?.length > 1}
    {#each images.slice(1) as img}
        <ImageWithCaption {img} />
    {/each}
{/if}

{#if post.text}
    <section
        class="mb-4 grid columns-1 justify-items-center pt-5 leading-5 md:text-xl md:leading-6"
    >
        <div class="whitespace-pre-wrap md:w-2/3 lg:w-1/2">
            {post.text}

            {#if post.textAuthor}
                <br />
                <div>
                    {post.textAuthor}
                </div>
            {/if}
        </div>
    </section>
{/if}

{#if morePosts?.length > 0}
    <MorePosts posts={shuffle(morePosts).slice(0, 3)} />
{/if}
